import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "checking") {
    return (
      <div data-testid="auth-loading" className="min-h-[50vh] flex items-center justify-center text-sm uppercase tracking-widest text-slate-400">
        Checking your session…
      </div>
    );
  }
  if (status !== "authed") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
